'use strict';

import { CoreRepository } from './CoreRepository';
import { App } from '../Entities/App';
import { AppCollection } from '../Collections/AppCollection';

export class AppRepository extends CoreRepository {
  public getApps(options = {}) {
    return this.webAPI.getApps(options).then((response) => {
      const collection = new AppCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new App();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getApp(appId: number, options: object = {}) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getApp(appId, options).then((response) => {
      const app = new App();
      app.hydrate(response);

      return app;
    });
  }
}
